<template>
  <TSideNavigation
    :primaryMenu="componentData.primaryMenu"
    :secondaryMenu="componentData.secondaryMenu"
    :showMenuCollapse="componentData.isCollapse"
    :currentRouteName="currentRouteName"
    @onClickCollapse="onClickCollapse"
    @onClickMenuItem="onClickMenuItem"
    @onClickChildMenuItem="onClickChildMenuItem"
  >
    <template #t-sidebar-logo>
      <AppLogo />
    </template>
    <template #t-sidebar-logo-collapse>
      <AppLogo is-collapse />
    </template>
  </TSideNavigation>
</template>

<script lang="ts" setup>
import { reactive, computed, onMounted, watch } from "vue"
import TSideNavigation from "./TSideNavigation.vue"
import AppLogo from "../AppLogo/AppLogo.vue"
import {
  primaryMenu,
  secondaryMenu,
  type IntChildEmitPayload,
  type IntMenuItemEmitPayload,
  type IntMenuItem
} from "./IntSidebarNav"
import { useRoute, useRouter } from "vue-router"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const emit = defineEmits<{ (e: "onClickCollapse", payload: boolean): void }>()

interface SidebarInt {
  primaryMenu: IntMenuItem[]
  secondaryMenu: IntMenuItem[]
  isCollapse: boolean
}

const componentData: SidebarInt = reactive({
  primaryMenu,
  secondaryMenu,
  isCollapse: false
})

const currentRouteName = computed((): string => {
  return String(route.name)
})

function onClickCollapse() {
  componentData.isCollapse = !componentData.isCollapse
  emit("onClickCollapse", componentData.isCollapse)
  if (componentData.isCollapse) {
    componentData.primaryMenu.forEach((item) => {
      item.isOpen = false
    })
    componentData.secondaryMenu.forEach((item) => {
      item.isOpen = false
    })
  }
}

function onClickMenuItem(payload: IntMenuItemEmitPayload): void {
  if (componentData.isCollapse) {
    componentData.isCollapse = !componentData.isCollapse
    emit("onClickCollapse", componentData.isCollapse)
  }
  if (payload.menuItem.hasChild) {
    if (payload.type === "primary") {
      componentData.primaryMenu[payload.index].isOpen = !payload.menuItem.isOpen
    }
    if (payload.type === "secondary") {
      componentData.secondaryMenu[payload.index].isOpen = !payload.menuItem.isOpen
    }
  } else if (route.name !== payload.menuItem.pathName) {
    router.push({ name: payload.menuItem.pathName })
  }
}

function onClickChildMenuItem(payload: IntChildEmitPayload) {
  if(payload.childItem.isExternalLink) {
    window.open(payload.childItem.path, '_blank')
  } else {
    if (payload.menuItem.iconClass == "prepare" && route.name == payload.childItem.pathName) {
      router.go(0)
    } else {
      router.push({
        name: payload.childItem.pathName
      })
    }
  }
  
}

function activateMenuItem() {
  const currentRouteName = route.name
  const currentItemMenu = componentData.primaryMenu.find((item) => {
    if (item.pathName && item.pathName === currentRouteName) {
      return item
    } else if (!item.pathName && item.childrens && item.childrens.length > 0) {
      const result = item.childrens.findIndex((child) => child.pathName === currentRouteName)
      return result > -1 ? item : undefined
    } else {
      return undefined
    }
  })
  if (currentItemMenu) {
    currentItemMenu.isOpen = true
  }
}

onMounted(() => {
  activateMenuItem()
})

watch(route, () => {
  activateMenuItem()
})
</script>
